export const stripNonDigits = (value = '') => {
  return value.replace(/\D+/g, '');
};

export const formatExpiration = value => {
  const clearValue = stripNonDigits(value);

  if (clearValue.length >= 3) {
    return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`;
  }

  return clearValue;
};
